import React from 'react';
import { Box, Typography} from '@mui/material';

const PageHeader = ({ title, subtitle }) => {
  return (
    <Box sx={{ mb: 2, px: { xs: 0, sm: 1 }, pt: 1, display: 'flex', alignItems: 'center', justifyContent: 'space-between' }}>
      <Box>
        <Typography variant="h5" fontWeight={600} color="primary.main" gutterBottom>
          {title}
        </Typography>
        {subtitle && (
          <Typography variant="body2" color="text.secondary" sx={{ fontSize: { xs: 13, sm: 14 } }}>
            {subtitle}
          </Typography>
        )}
      </Box>
    </Box>
  );
};

export default PageHeader;
